'use strict';

import React, { Component } from 'react'

import Loader from '@Pure/Loader'

import Modal from '@Modal/Modal'

import getFormStatus from '@/Form/Functions/getFormStatus'

import _ from 'lodash'

const { app, qwest } = window;

export default class CancelProductModal extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: [],
			form_data: { },
			status_messages: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.open        = this.open.bind(this);
		this.cancel      = this.cancel.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'open__CancelProductModal',
			cb: component.open
		});

		component.setState(
		{
			open: false,
			canceled: undefined,
			error: undefined,
			data: []
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'open__CancelProductModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			data: [],
			canceled: undefined,
			error: undefined,
			form_data: { },
			status_messages: { }
		});
	}

/**
 *	data:
 *	[
 * 		{
 *   		ticket    :  ticket data (optional)  Object
 *   		ticket_id :  ticket id (optional)    String
 * 			product   :  product data            Object
 *			order     :  order data              Object
 * 		}
 *   ]
 **/
	open (data)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open : true,
			data: data,
			info: undefined,
			warning: 'Souhaitez-vous vraiment annuler le produit ' + data.product.name + ' ?'
		});
	}

	cancel (e)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/order/cancel-product',
		{
			order_id: state.data.order.id,
			product_id: state.data.product.id,
			ticket_id: state.data.ticket_id,
			ref: state.data.ref
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				canceled: true,
				info: response.info,
				error: undefined,
				warning: response.warning
			});

			app.emit('canceledProduct',
			{
				order_id: state.data.order.id,
				product_id: state.data.product.id,
				ticket_id: state.data.ticket_id,
				ref: state.data.ref,
				tickets: state.data.tickets
			});
		})
		.catch(function (error, xhr, response)
		{
			if (error) console.error(error);

			component.setState(
			{
				loading: false,
				info: undefined,
				error: response.error,
				warning: response.warning
			});
		});
	}

	render (e)
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		const form_status =
		[
			{ label: 'info', suffix: '--green' },
			{ label: 'warning', suffix: '--orange' },
			{ label: 'error', suffix: '--red' }
		];

		let action_btn;

		if (!state.canceled)
		{
			action_btn =
			(
				<button className="c-btn c-dialog__danger u-margin-left-10"
					onClick={ component.cancel }>
					Annuler ce produit
				</button>
			);
		}

		let output =
		(
			<Modal className="o-modal o-modal--large" open={ component.state.open }
				hide_close={ true } title="Annuler un produit"
				onClose={ component.handleClose }>

				{ getFormStatus(state) }

				<div className="c-dialog__buttons">
					<button type="button" className="c-btn c-dialog__cancel u-margin-right-0"
						onClick={ component.handleClose }>
						Fermer
					</button>

					{ action_btn }
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
